export default __webpack_public_path__ + "static/media/table-sort-caret-up.c7e76412.svg";